import { render, staticRenderFns } from "./FollowSocial.vue?vue&type=template&id=87875f42"
import script from "./FollowSocial.vue?vue&type=script&lang=js"
export * from "./FollowSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports